// extracted by mini-css-extract-plugin
export default {"container":"er-z","heading":"fr-z","text":"gr-z","info":"hr-z","link":"ir-z","fullMaxWidth":"jr-z"};